import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function HealthImprovementsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.healthImprovements.heading')}
      buttons={[
        {
          text: t(
            'pages.onboarding.healthImprovements.options.better-breathing',
          ),
          value: 'better-breathing',
        },
        {
          text: t('pages.onboarding.healthImprovements.options.more-energy'),
          value: 'more-energy',
        },
        {
          text: t(
            'pages.onboarding.healthImprovements.options.better-taste-smell',
          ),
          value: 'better-taste-smell',
        },
        {
          text: t('pages.onboarding.healthImprovements.options.healthier-skin'),
          value: 'healthier-skin',
        },
        {
          text: t('pages.onboarding.healthImprovements.options.heart-health'),
          value: 'heart-health',
        },
        {
          text: t('pages.onboarding.healthImprovements.options.better-sleep'),
          value: 'better-sleep',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
